<template>
  <BaseTemplate :searchPurchase="searchPurchase">
    <div class="purchase-class">
      <Title class="_title" :jpn="t('買取表')" />
      <!-- 検索フォーム -->
      <div class="search-container">
        <div class="search-bar">
          <input type="text" v-model="freeword" @change="search(1)" />
          <button class="search-button">
            🔍
          </button>
        </div>

        <div class="filter-section">
          <div class="filter-buttons">
            <button
              v-for="title in decodedSelectType"
              :key="title.id"
              @click="selectTitle(title)"
              :class="{ active: type === title.id }"
              class="color-button"
            >
              {{ t(title.name) }}
            </button>
            <div class="psa-filters">
              <label class="psa-checkbox">
                <input type="checkbox" v-model="psaOnly" @change="onPsaFilterChange('only')" />
                <span>{{ t('PSAのみ表示') }}</span>
              </label>
              <label class="psa-checkbox">
                <input type="checkbox" v-model="psaHide" @change="onPsaFilterChange('hide')" />
                <span>{{ t('PSAを非表示') }}</span>
              </label>
            </div>
          </div>
        </div>
        <div class="price-range">
          <div class="price-inputs">
            <div class="border">
              <input type="number" v-model="price_from" @change="search(1)" />
              <span>〜</span>
              <input type="number" v-model="price_to" @change="search(1)" />
              <span class="filter-title">{{t('円')}}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- <p>{{ cardList }}</p> -->
      <div class="card-list">
        <PurchaseCardList
          v-if="cardList"
          :cardList="cardList.list"
          :cardListTitle="t('検索結果')"
        />
        <BoxPager
        v-if="cardList.page.pages && cardList.page.pages.length > 1"
        class="box-pager"
        :totalPageCount="cardList.page.all_page"
        :currentPageCount="cardList.page.page"
        :dispBoxCount="cardList.page.pages.length"
        :pages="cardList.page.pages"
        @handlePagerClick="changeCurrentPageCount"
        @handleSquareBtnClick="changeCurrentPageCount"
      />
      </div>
      <div class="footer-menu">
        <button class="menu-button-left" @click="openModal('procedure')">{{t('手順確認')}}</button>
        <button
          class="menu-button-right"
          :class="{ disabled: !isLoggedIn }"
          @click="isLoggedIn ? openModal('application') : openLoginPopup()"
        >
          {{ isLoggedIn ? t('買取申込') : t('買取申込(会員様限定)') }}
        </button>
      </div>
      <CommonOverlay @handleOverlayClick="closeModal" class="overlay_conf"  v-if="modalType === 'procedure'" >
        <CommonModal @click.stop class="modal purchase-modal">
          <PurchaseProcedure
            :isLoggedIn="isLoggedIn"
            @handleCancel="closeModal"
            @handleApplication="openModal('application')"
          />
        </CommonModal>
      </CommonOverlay>
      <CommonOverlay @handleOverlayClick="closeModal" class="overlay_conf" v-if="modalType === 'application'">
        <CommonModal  class="modal purchase-modal">
          <PurchaseApplication
            :currentUser="currentUser"
            :errorMessage="errorMessage"
            @handleCancel="closeModal"
            @submitApplication="submit($event)"
          />
        </CommonModal>
      </CommonOverlay>
      <CommonOverlay class="overlay_conf" v-if="modalType === 'complete'">
        <CommonModal class="modal purchase-modal">
          <div class="complete-container" @click.stop>
            <p class="complete-message">
              {{ t('お申し込みありがとうございます。お品物が到着次第、ご連絡いたします。引き続きどうぞよろしくお願いいたします。') }}
            </p>
            <div class="button-group">
              <button class="close-button" @click="closeModal">{{ t('閉じる') }}</button>
            </div>
          </div>
        </CommonModal>
      </CommonOverlay>
      <LoginPopup />
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import t from '@/plugins/i18n';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import PurchaseCardList from '@/components/organisms/PurchaseCardList.vue';
import Title from '@/components/molecules/TitlePurchase.vue';
import CommonOverlay from '@/components/atoms/CommonOverlay.vue';
import CommonModal from '@/components/atoms/CommonModal.vue';
import BoxPager from '@/components/organisms/BoxPager.vue';
import PurchaseProcedure from '@/components/organisms/PurchaseProcedure.vue';
import PurchaseApplication from '@/components/organisms/PurchaseApplication.vue';
import LoginPopup from '@/components/organisms/LoginPopup.vue';

export default {
  name: 'PurchaseCard',
  mixins: [t],
  components: {
    BaseTemplate,
    Title,
    PurchaseCardList,
    BoxPager,
    CommonModal,
    CommonOverlay,
    PurchaseProcedure,
    PurchaseApplication,
    LoginPopup,
  },
  data() {
    return {
      freeword: '',
      type: null,
      price_from: null,
      price_to: null,
      page: 1,
      isModal: false,
      modalType: '', // 'procedure' or 'application' or  'complete',
      postData: {},
      errorMessage: {},
      psaOnly: false,
      psaHide: false,
    };
  },
  computed: {
    ...mapGetters({
      searchPurchase: 'purchaseList/resultPurchaseSearch',
      resultPurchaseSave: 'purchaseList/resultPurchaseSave',
      selectType: 'cardType/cardTypeList',
      currentUser: 'user/currentUser',
    }),
    cardList() {
      if (this.searchPurchase) {
        return this.searchPurchase;
      }
      return [];
    },
    postParam() {
      return {
        freeword: this.freeword || null,
        type: this.type || null,
        price_from: this.price_from || null,
        price_to: this.price_to || null,
        psa_only: this.psaOnly ? 1 : null,
        psa_hide: this.psaHide ? 1 : null,
      };
    },
    decodedSelectType() {
      const allowedIds = [2, 5]; // 表示したいタイトルのIDを配列で指定
      if (this.selectType) {
        return this.selectType
          .filter((item) => allowedIds.includes(item.id))
          .map((item) => ({
            id: item.id,
            name: item.name,
          }));
      }
      return [];
    },
    // 会員判定のcomputedプロパティを追加
    isLoggedIn() {
      return this.currentUser && this.currentUser.is_login !== '0';
    },
  },
  watch: {
    resultPurchaseSave(newResult) {
      if ((newResult.state !== 200) || (newResult.error && newResult.error.length !== 0)) {
        this.errorMessage = newResult.error;
        return;
      }
      this.modalType = 'complete';
      this.errorMessage = {};
    },
  },
  created() {
    const { postParam } = {};
    this.$store.dispatch('purchaseList/search', { postParam });
    this.$store.dispatch('cardType/setCardTypeList');
  },
  methods: {
    selectTitle(title) {
      if (this.type === title.id) {
        this.type = null;
      } else {
        this.type = title.id;
      }
      this.search();
    },
    openModal(type) {
      this.modalType = type;
      this.isModal = true;
    },
    closeModal() {
      this.isModal = false;
      this.modalType = '';
    },
    changeCurrentPageCount(page) {
      this.page = page;
      this.search(page);
    },
    search(page = 1) {
      this.$store.dispatch('purchaseList/search', {
        pageNumber: page,
        postParam: this.postParam,
      });
    },
    submit(postData) {
      if (!postData) {
        return;
      }
      this.$store.dispatch('purchaseList/save', { postParam: postData });
    },
    openLoginPopup() {
      // TODO: 一旦ログインポップアップを表示しないように
      // this.$store.dispatch('user/setShowLoginPage', true);
    },
    onPsaFilterChange(filterType) {
      // 両方同時に選択できないようにする
      if (filterType === 'only' && this.psaOnly) {
        this.psaHide = false;
      } else if (filterType === 'hide' && this.psaHide) {
        this.psaOnly = false;
      }
      this.search(1);
    },
  },
};
</script>

<style lang="scss" scoped>
.purchase-class{
  width: 100%;
  min-height: 100vh;
  margin: 0 auto ;
  color: #042859;
  ._title {
    margin-top: 20px;
    max-width: 900px;
    margin: 0 auto;
  }
  //検索バーとフィルター___________________
  .search-container {
    max-width: 900px;
    // background-color: #f0f0f0;
    margin: 0 auto;
    width: 90%;
    padding: 20px;
    text-align: center;
    .search-bar {
      display: flex;
      align-items: center;
      background: #fff;
      border-radius: 20px;
      padding: 5px 10px;
      position: relative;
      box-shadow:
        0 0 0 1.5px #2cbaf0,
        0 0 0 3px #ffffe1,
        0 0 0 4.5px #2cbaf0;
      margin-bottom: 20px;
      input {
        flex-grow: 1;
        border: none;
        outline: none;
        font-size: 16px;
      }
      .search-button {
        background: none;
        border: none;
        font-size: 18px;
        cursor: pointer;
      }
    }
    .filter-section,.price-range {
      margin-bottom: 15px;
      .filter-title {
        font-size: 14px;
        color: gray;
        font-weight: bold;
      }
      .filter-buttons {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 5px;
        flex-wrap: wrap;
        .psa-filters {
          display: flex;
          gap: 10px;
          margin-left: 20px;
          @media screen and (max-width: $tabletWidth) {
            margin-left: 0;
            margin-top: 10px;
            width: 100%;
            justify-content: center;
          }
          .psa-checkbox {
            display: flex;
            align-items: center;
            gap: 5px;
            cursor: pointer;
            font-size: 14px;
            font-weight: bold;
            color: #2b5dcf;
            white-space: nowrap;
            input[type="checkbox"] {
              width: 18px;
              height: 18px;
              cursor: pointer;
            }
            @media screen and (max-width: $tabletWidth) {
              font-size: 12px;
            }
          }
        }
        .color-button {
          white-space: nowrap;
          position: relative;
          padding: 10px 10px;
          font-size: 16px;
          font-weight: bold;
          color: #2b5dcf;
          background: white;
          border: none;
          border-radius: 25px;
          cursor: pointer;
          transition: all 0.3s ease-in-out;
          &::before {
            content: "";
            position: absolute;
            inset: 0;
            border-radius: 25px;
            padding: 3px;
            background: linear-gradient(90deg, #74a6f7bd, #ff80c0bd, #ffff80bd, #80ff80bd);
            -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
            mask-composite: exclude;
            -webkit-mask-composite: xor;
          }
          &.active {
            background: #182f5c42;
          }
          @media screen and (max-width: $tabletWidth) {
            padding: 8px 8px;
            font-size: 11px;
          }
        }
      }
      .price-inputs {
        display: flex;
        justify-content: center;
        gap: 10px;
        align-items: center;
        background: linear-gradient(90deg, #bbe2f4, #f49bc4, #fdf7a3, #99d6b4);
        padding: 2px;
        width:100%;
        margin:0 auto;
        border-radius: 10px;
        .border{
          width:100%;
          display: flex;
          justify-content: center;
          gap: 10px;
          align-items: center;
          background: linear-gradient(90deg, #cfe7f6, #facede, #fffbcc, #d0ecda);
          border-radius: 9px;
          padding: 13px;
        }
        input {
          width: 100px;
          padding: 6px;
          font-size: 14px;
          background-color: #fff;
          border: 1px solid #ddd;
          border-radius: 5px;
        }
      }
    }
  }
  //カード一覧_____________________________
  .card-container {
    margin: 0 auto;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    gap: 15px;
    padding: 20px;
  }
  // フッターメニュー
  .footer-menu {
    display: flex;
    justify-content: space-between;
    gap: 15px;
    width: 90%;
    position: fixed;
    bottom: 97px;
    left: 50%;
    transform: translateX(-50%);
    padding: 0;
    z-index: 10;
    @media screen and (max-width: $tabletWidth) {
      bottom: 66px;
      gap: 2px;
      width: 97%;
    }
    .menu-button-left,.menu-button-right {
      flex: 1;
      text-align: center;
      font-weight: bold;
      padding: 10px;
      font-size: 18px;
      border: none;
      cursor: pointer;
      outline: none;
      transition: all 0.3s ease-in-out;
      border-radius: 10px;
      box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.2);
      @media screen and (max-width: $tabletWidth) {
        padding: 4px;
        font-size: 14px;
      }
    }
  .menu-button-left {
    color: white;
    background: linear-gradient(to bottom, #3fcdff, #1085d0); // 青色グラデーション
    &:hover {
      background: linear-gradient(to bottom, #49a8ff, #0d75bb);
    }
  }
  .menu-button-right {
    color: #323232;
    background: linear-gradient(to bottom, #fff100, #ff9800); // 黄色グラデーション
    &:hover {
      background: linear-gradient(to bottom, #ffd04a, #ff8f00);
    }
    &.disabled {
      color: #999;
      background: linear-gradient(to bottom, #ccc, #999); // グレーグラデーション
      cursor: default;
      &:hover {
        background: linear-gradient(to bottom, #ccc, #999); // ホバー時も同じグレー
      }
    }
  }
}
  .overlay_conf{
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    .purchase-modal {
      max-height: 90svh;
      border: none;
      box-shadow:  0 0px 20px rgba(0, 0, 0, 1.0);
      border-radius: 10px;
      max-width: 700px;
      overflow-y: auto;
      padding: 15px;
      position: relative;
      width: 100%;
      @media screen and (max-width: $tabletWidth) {
        max-width: 530px;
      }
      .block {
        padding: 5px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        margin: 5px 20px;
        font-weight: bold;
        text-align: center;
      }
      .complete-container {
        padding: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .complete-message {
          font-size: 16px;
          font-weight: bold;
          color: #333;
          margin-bottom: 20px;
        }
        .button-group {
          display: flex;
          justify-content: center;
          margin-top: 20px;
          .close-button {
            padding: 10px 60px;
            background: #a1a2a2;
            color: white;
            font-size: 16px;
            font-weight: bold;
            border: none;
            cursor: pointer;
            box-shadow: 0 0 5px rgba(0, 0, 0, 0.4);
          }
        }
      }
    }
  }
}
</style>
